<mat-dialog-content>
  <p *ngIf="config.message">{{ config.message }}</p>
  <div *ngIf="config.messageHTML" [innerHTML]="config.messageHTML"></div>
</mat-dialog-content>

<mat-dialog-actions *ngIf="config.actionDialog">
  <button
    mat-raised-button
    color="primary"
    *ngIf="config.actionAccept"
    [disabled]="config.disabledButton"
    (click)="dialogRef.close(true)"
    tabindex="1"
  >
    {{ acceptDialog }}
  </button>

  <button mat-raised-button *ngIf="config.actionDismiss" (click)="dialogRef.close()" tabindex="-1">
    {{ dismissDialog }}
  </button>
</mat-dialog-actions>
